import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { AppContext } from '../context/appContext'
import {
    Box,
    Button,
    CircularProgress,
    Paper,
    Typography
} from '@mui/material'
import './css/email-verify.css'

const EmailVerify = () => {
    const { backendUrl, isLoggedIn, userData, getUserData } = useContext(AppContext);
    const inputRefs = useRef([]);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);

    const handleChange = (e, index) => {
        const value = e.target.value;

        if (index === 0 && value.length === 6) {
            value.split('').forEach((digit, i) => {
                if (inputRefs.current[i]) inputRefs.current[i].value = digit;
            });
            inputRefs.current[5].focus();
            return;
        }

        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && e.target.value === '' && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    }

    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData("text").slice(0, 6).split("");

        pasted.forEach((ch, i) => {
            if (inputRefs.current[i]) inputRefs.current[i].value = ch;
        });

        inputRefs.current[5].focus();
    };

    const onSubmitHandler = async (e) => {
        e.preventDefault();
        const otpArray = inputRefs.current.map((input) => input.value);
        const otp = otpArray.join('');
        try {
            setLoading(true);
            const { data } = await axios.post(`${backendUrl}/api/auth/verify-account`, { otp });
            if (data.success) {
                getUserData();
                navigate('/');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const resendOtp = async () => {
        try {
            setResendLoading(true);
            const { data } = await axios.post(`${backendUrl}/api/auth/send-verify-otp`);
            if (data.success) {
                console.log('OTP Resent:', data.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setResendLoading(false);
        }
    }

    useEffect(() => {
        if (userData === null || isLoggedIn === null) return;

        if (!isLoggedIn) {
            navigate('/login');
            return;
        }

        if (isLoggedIn && userData && userData.isAccountVerified) {
            navigate('/');
            return;
        }
    }, [isLoggedIn, userData, navigate]);

    return (
        <Box className="verify-page">
            <Paper elevation={10} className="verify-container">
                <Typography variant="h4" className="verify-title">
                    Verify Your Email
                </Typography>
                <Typography variant="body2" className="verify-subtitle">
                    Enter the 6-digit code sent to your email address
                </Typography>

                <form onSubmit={onSubmitHandler}>
                    <Box className="otp-fields" onPaste={handlePaste}>
                        {Array(6)
                            .fill(0)
                            .map((_, i) => (
                                <input
                                    key={i}
                                    type="text"
                                    maxLength="1"
                                    required
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                    ref={(e) => (inputRefs.current[i] = e)}
                                    onChange={(e) => handleChange(e, i)}
                                    onKeyDown={(e) => handleKeyDown(e, i)}
                                    className="otp-input"
                                />
                            ))}
                    </Box>

                    <Box className="resend-otp-con">
                        <Button
                            variant="text"
                            color="primary"
                            onClick={resendOtp}
                            disabled={resendLoading}
                            className="resend-otp"
                        >
                            {resendLoading ? <CircularProgress size={18} color="inherit" /> : 'Resend OTP'}
                        </Button>
                    </Box>

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className="verify-btn"
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={22} color="inherit" /> : 'Verify Email'}
                    </Button>
                </form>
            </Paper>
        </Box>
    );
};

export default EmailVerify;